<template>
    <b-col cols="12" md="6">
        <default-form-validation-provider label="Há previsão de pagamento antecipado?"
            tooltip="Quando houver previsão de antecipação de pagamento nos moldes da MP 961/2020, marcar SIM neste campo e juntar a justificativa sobre a antecipação de pagamento ao aquivo do Edital da Licitação ou da Justificativa da Dispensa/Inexigibilidade.">
            <b-form-radio-group v-model="opcaoSelecionada" :options="pagamentoAntecipadoOptions" @input="procedimentoOrigemAtualizado"
                size="sm">
            </b-form-radio-group>
        </default-form-validation-provider>
    </b-col>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'

const CompProps = Vue.extend({
    name: 'EditarProcedimentoOrigemDispensa',
    components: { DefaultFormValidationProvider },
    props: {
        ctr: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class EditarProcedimentoOrigemDispensa extends mixins(UtilsTS, CompProps) {
    contrato: Contrato = new Contrato()
    pagamentoAntecipadoOptions = [
        { text: 'Sim', value: 'S' },
        { text: 'Não', value: 'N' },
    ]
    opcaoSelecionada: string | null = null

    async mounted() {
        try {
            this.contrato = this.ctr
            if (this.ctr.IdContrato > 0) {
                this.opcaoSelecionada = this.contrato.FlPagamentoAntecipado
                this.contrato.tratarDadosDaAPI()
            }
            store.blockScreen = true
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarProcedimentoOrigemDispensa', e)
        } finally {
            store.blockScreen = false
        }
    }

    procedimentoOrigemAtualizado() {
        this.contrato.FlPagamentoAntecipado = this.opcaoSelecionada as string
        //console.log("procOrigemAtualizado dispensa", this.contrato)
        this.$emit('input', this.contrato)
    }
}


</script>

<style scoped>
    :deep(svg) {
        padding-bottom: 0.75em;
    }
</style>